<template>
  <div class="content">
    <div class="search">
      <!--      <template>-->
      <!--        <Select v-model="searchForm.type" style="width:150px" placeholder="事件类型">-->
      <!--          <Option v-for="item in type_list" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
      <!--        </Select>-->
      <!--      </template>-->
      <!--      <template>-->
      <!--        <Select v-model="searchForm.is_income" style="width:150px" placeholder="收入类型">-->
      <!--          <Option v-for="item in is_income_list" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
      <!--        </Select>-->
      <!--      </template>-->
      <!--      <template>-->
      <!--        <input class="input-search" v-model="searchForm.relation_id"  placeholder="请输入订单号"></input>-->
      <!--      </template>-->
      <span style="margin-right: 10px">选择日期</span>
      <el-date-picker
        style="width: 268px"
        v-model="time"
        type="daterange"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <!--        <DatePicker type="date" placeholder="开始时间" v-model="searchForm.start_time_bak" style="width: 150px;margin-right: 10px" @on-change = "handelDateChangeStart"></DatePicker>-->
      <!--        <span>至</span>-->
      <!--        <DatePicker type="date" placeholder="结束时间" v-model="searchForm.end_time_bak" style="width: 150px;" @on-change = "handelDateChange"></DatePicker>-->
      <Button
        type="text"
        style="
          background: #ff8622;
          color: #ffffff;
          margin-right: 10px;
          margin-left: 10px;
        "
        @click="handleFilter"
        >查询</Button
      >
      <!--        <Button type="primary" @click="exportData">导出</Button>-->
      <Button
        type="text"
        style="background: #ff8622; color: #ffffff; margin-right: 10px"
        @click="reset"
        >重置</Button
      >
    </div>
    <div class="table">
      <div class="box">
        <el-table
          v-loading="searchForm.Loading"
          :data="list"
          border
          highlight-current-row
          style="width: 100%"
          header-row-class-name="header"
        >
          <el-table-column label="明细时间" width="180" prop="create_time">
          </el-table-column>
          <el-table-column label="事件类型" prop="type_str"> </el-table-column>
          <el-table-column label="明细说明" prop="remark" width="280">
            <template slot-scope="{ row }">
              <span>
                <div v-for="(item, index) in row.arr" :key="index">
                  {{ item }}
                </div>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="订单号" prop="relation_id" width="140">
          </el-table-column>
          <el-table-column label="变动金额" prop="amount"> </el-table-column>
          <el-table-column label="变动后余额" prop="after_amount">
          </el-table-column>
        </el-table>
        <!--    分页-->
        <el-pagination
          v-if="tableList.total > 0"
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="tableList.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableList.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Icon,
  Table,
  Page,
  Button,
  Select,
  Option,
  Input,
  DatePicker,
} from "view-design";
import { getUserBalanceList } from "@/api/user";
import { getDate, formatDate } from "@/utils/date";
export default {
  name: "PromotionOrder",
  components: {
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    Input,
    DatePicker,
  },
  data: function () {
    return {
      time: [],
      currentPage: 1,
      columns: [
        {
          title: "明细时间",
          key: "create_time",
        },
        {
          title: "事件类型",
          key: "type_str",
        },
        {
          title: "明细说明",
          key: "remark",
        },
        {
          title: "订单号",
          key: "relation_id",
        },
        {
          title: "变动金额",
          key: "amount",
        },
        {
          title: "变动后余额",
          key: "after_amount",
        },
      ],
      listLoading: false,
      list: [],
      total: 0,
      searchForm: {
        page: 1,
        pagesize: 10,
        is_income: undefined,
        type: 30,
        start_time_bak: "",
        end_time_bak: "",
        start_time: undefined,
        end_time: undefined,
        sort: "-id",
        relation_id: "",
      },
      is_income_list: [
        { value: "", label: "全部" },
        { value: "1", label: "收入" },
        { value: "2", label: "支出" },
      ],
      type_list: [],
      tableList: [],
    };
  },
  mounted() {
    this.getList(true);
  },
  methods: {
    handleSizeChange(val) {
      this.searchForm.pagesize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    getList(first = false) {
      this.listLoading = true;
      if (first) this.searchForm.page = 1;
      let searchForm = Object.assign({}, this.searchForm);
      searchForm.start_time = getDate(searchForm.start_time_bak);
      searchForm.end_time = getDate(searchForm.end_time_bak);
      delete searchForm.start_time_bak;
      delete searchForm.end_time_bak;
      getUserBalanceList(searchForm)
        .then((response) => {
          this.listLoading = false;
          if (response.code != 200) {
            this.$Message.error(response.msg);
            return;
          }
          this.tableList = response.data;
          this.list = response.data.list;
          this.total = response.data.total;
          this.type_list = response.data.type_list;
          for (const index in this.list) {
            this.list[index].arr = this.list[index].remark.split("<br>");
          }
        })
        .catch((error) => {
          this.listLoading = false;
          console.log(error);
        });
    },
    rowClassName: function (row, index) {
      if (index % 2 === 0) {
        return "bg-fa";
      } else {
        return "bg-white";
      }
    },
    handleFilter(){
      if(this.time){
        this.searchForm.start_time_bak = this.time[0]
        this.searchForm.end_time_bak = this.time[1]
      }else {
        this.searchForm.start_time_bak = ''
        this.searchForm.end_time_bak = ''
      }
      this.getList(true)
    },
    reset() {
      this.time = [];
      this.searchForm.is_income = "";
      this.searchForm.type = 30;
      this.searchForm.start_time_bak = "";
      this.searchForm.end_time_bak = "";
      this.searchForm.start_time = "";
      this.searchForm.end_time = "";
      this.searchForm.relation_id = "";
      this.getList();
    },
    changePage(value) {
      this.searchForm.page = value;
      this.getList();
    },
    changePagesize(value) {
      this.searchForm.pagesize = value;
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.page == 1) {
        this.getList();
      }
    },
    handelDateChange: function (time, type) {
      if (type == "date") {
        if (this.searchForm.start_time_bak !== "") {
          if (this.compareTime(this.searchForm.start_time_bak, time)) {
            this.searchForm.end_time_bak = this.searchForm.start_time_bak;
          }
        }
      }
    },
    handelDateChangeStart: function (time, type) {
      if (type == "date") {
        if (this.searchForm.end_time_bak !== "") {
          if (this.compareTime(time, this.searchForm.end_time_bak)) {
            this.searchForm.start_time_bak = this.searchForm.end_time_bak;
          }
        }
      }
    },
    compareTime: function (startTime, endTime) {
      var oDate1 = new Date(startTime);
      var oDate2 = new Date(endTime);
      if (oDate1.getTime() > oDate2.getTime()) {
        return true;
      } else {
        return false;
      }
    },
    exportData: function () {
      let searchForm = Object.assign({}, this.searchForm);
      searchForm.page = 1;
      searchForm.pagesize = 50000;
      searchForm.start_time = getDate(searchForm.start_time_bak);
      searchForm.end_time = getDate(searchForm.end_time_bak);
      delete searchForm.start_time_bak;
      delete searchForm.end_time_bak;
      getUserBalanceList(searchForm)
        .then((res) => {
          if (res.code != 200) {
            this.$message.error(res.message);
            return;
          }
          let filename = "资金明细" + formatDate("yyMMddhhmmss");
          let header = [
            "明细时间",
            "事件类型",
            "明细说明",
            "订单号",
            "变动类型",
            "变动后余额",
          ];
          let data = res.data.list.map((x) => {
            return [
              x.create_time,
              x.type_str,
              x.mingxi_detail,
              x.relation_id,
              x.amount,
              x.after_amount,
            ];
          });
          import("@/vendor/Export2Excel").then((excel) => {
            excel.export_json_to_excel({
              header,
              data,
              filename,
            });
            this.$message.success("导出成功");
          });
        })
        .catch((error) => {
          this.$message.error(error.toString());
        });
    },
  },
};
</script>
<style scoped>
.center {
  width: 100%;
}
.search {
  background: #ffffff;
  border-radius: 8px;
  padding: 26px 20px;
  display: flex;
  align-items: center;
  /*justify-content: space-between;*/
}
.table {
  padding: 20px 21px;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 16px;
}
.wrapper .tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}
.wrapper .table-wrapper {
  margin-top: 0.62rem;
}
.table-wrapper .show-excel {
  font-size: 14px;
  color: #ff4f76;
  cursor: pointer;
  display: inline-block;
  padding-right: 7px;
}
.table-wrapper .show-excel:last-child {
  padding-right: 0px;
}
.input-search {
  width: 150px;
  height: 30px;
  height: 32px;
  line-height: 1.5;
  padding: 4px 7px;
  font-size: 14px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
}
input::placeholder {
  font-size: 14px;
  color: #c5c8ce !important;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/financialDetails/index.vue